import axios from 'axios';
import { alertController } from '@ionic/vue';
import i18n from '../i18n';

const axiosInstance = axios.create({
  baseURL: 'https://your-api-base-url.com',
});

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const { t } = i18n.global;
    const config = error.config || {};
    const reloadOnClose = config.reloadOnClose === true;

    console.error("Network error detected:", error);

    if (!error.response) {
      console.error("Network error - no response received", {
        config: error.config,
        request: error.request,
        code: error.code
      });

      const alert = await alertController.create({
        header: t('networkErrorTitle'),
        message: t('networkErrorMessage'),
        buttons: ['OK'],
      });

      await alert.present();
      await alert.onDidDismiss();

      if (reloadOnClose) {
        window.location.reload();
      }

    } else {
      const alert = await alertController.create({
        header: t('errorOccurred'),
        message: error.response.data.message || t('errorOccurredMessage'),
        buttons: ['OK'],
      });

      await alert.present();
      await alert.onDidDismiss();

      if (reloadOnClose) {
        window.location.reload();
      }
    }

    return Promise.resolve({ data: null, error: true });
  }
);

export default axiosInstance;
